module.exports = "/virtual-football-league/img/amblems/left/logos/FakeCardiffCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/FakeCardiffCity.png
// module id = 2070
// module chunks = 4